import Entity from "./entity";

/**
 * Represents a category associated to one or several products.
 */
class Category extends Entity {
  constructor({ id, restaurantId, name, index } = {}) {
    super({ id: id, restaurantId: restaurantId });
    this.name = name;
    this.index = index;
  }

  static _fromMap(snapData) {
    return new Category(snapData);
  }

  _toMap() {
    return { id: this.id, name: this.name, index: this.index };
  }

  /**
   * @returns {string} A `string` representation of the collection to which this
   * `Category` belongs to.
   */
  get _functionUrl() {
    return "categories";
  }

  get _collectionName() {
    return `categories`;
  }

  get _entityName() {
    return "category";
  }
}

export default Category;
